import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { CommonModule as BluecrewCommonModule } from '../common/common.module';
import { DashboardPageRoutingModule } from './dashboard-routing.module';

import { DashboardPage } from './dashboard.page';
import { JobApplicationComponent } from './job-application/job-application.component';
import { PipeModule } from '../pipes/pipe.module';
import { CompleteProfileComponent } from './complete-profile/complete-profile.component';
import { ImgTextImgComponent } from './templates/img-text-img/img-text-img.component';
import { TextComponent } from './templates/text/text.component';
import { PostSubmitPageModule } from '../application-home/post-submit/post-submit.module';
import { TopJobsComponent } from './top-jobs/top-jobs.component';
import { TodaysShiftComponent } from './todays-shift/todays-shift.component';
import { UpcomingJobsComponent } from './upcoming-jobs/upcoming-jobs.component';
import { ImportantTasksComponent } from './important-tasks/important-tasks.component';
import { ImportantTasksCardComponent } from './important-tasks/important-tasks-card/important-tasks-card.component';
import { ImportantTasksCardCarouselComponent } from './important-tasks/important-tasks-card-carousel/important-tasks-card-carousel.component';
import { SwiperModule } from 'swiper/angular';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    BluecrewCommonModule,
    DashboardPageRoutingModule,
    PipeModule,
    PostSubmitPageModule,
    SwiperModule
  ],
  declarations: [
    DashboardPage, 
    JobApplicationComponent,
    TopJobsComponent,
    CompleteProfileComponent, 
    ImgTextImgComponent, 
    TextComponent,
    TodaysShiftComponent,
    UpcomingJobsComponent,
    ImportantTasksComponent,
    ImportantTasksCardComponent,
    ImportantTasksCardCarouselComponent
  ]
})
export class DashboardPageModule {}
